import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { clearClientCreds } from '../clientSession';
import PulseLogo from './PulseLogo';
import { useI18n } from '../i18n';

function ClientPortalLayout({ companyName, logoUrl, customer, children }) {
    const navigate = useNavigate();
    const { t } = useI18n();
    const name = (customer && customer.fullName) || 'Policyholder';

    const logout = () => {
        clearClientCreds();
        navigate('/client/login');
    };

    return (
        <div className="att-shell cp-shell">
            <header className="cp-top no-print">
                <div className="cp-top-inner">
                    <Link to="/client" className="cp-brand">
                        <PulseLogo size="small" showTagline={false} variant="dark" companyName={companyName} logoUrl={logoUrl} />
                    </Link>
                    <div className="cp-top-actions">
                        <div className="cp-who">
                            <span>{t('client.signedIn')}</span>
                            <strong>{name}</strong>
                        </div>
                        <button type="button" className="cp-logout" onClick={logout}>{t('client.logOut')}</button>
                    </div>
                </div>
            </header>
            <nav className="cp-nav no-print">
                <Link to="/client" className="cp-nav-link">{t('client.certificates')}</Link>
                <a href="#fnol" className="cp-nav-link">{t('client.fnolTitle')}</a>
            </nav>
            <div className="cp-main">{children}</div>
        </div>
    );
}

export default ClientPortalLayout;
